import React from "react"
import { graphql } from "gatsby"
import { FlexibleContent } from "wordsby-components"

import Hero from "./Hero"
import Breadcrumbs from "../Breadcrumbs"
import Cards from "./Cards"
import BulletList from "./BulletList"
import Features from "./Features"
import ContactInfo from "./ContactInfo"
import ActionBox from "./ActionBox"
import InfoBox from "./InfoBox"
import ImageTiles from "./ImageTiles"
import MapBox from "../MapBox/MapBox"
import Testimonials from "./Testimonials"

export default ({ rows, data }) => (
  <FlexibleContent
    rows={rows}
    components={{
      hero: Hero,
      breadcrumbs: Breadcrumbs,
      cards: Cards,
      bullet_list: BulletList,
      features: Features,
      contact_info: ContactInfo,
      call_to_action: ActionBox,
      info_box: InfoBox,
      image_tiles: ImageTiles,
      map: MapBox,
      testimonials: Testimonials
    }}
    data={data}
  />
)

export const query = graphql`
  fragment flexibleContent on Node {
    __typename
    ... on WordPressAcf_testimonials {
      testimonials {
        name
        quote
      }
    }
    __typename
    ... on WordPressAcf_map {
      map {
        lat
        lng
      }
    }
    __typename
    ... on WordPressAcf_image_tiles {
      images {
        image {
          alt
          url {
            childImageSharp {
              fluid(quality: 90, maxWidth: 1440) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
    __typename
    ... on WordPressAcf_info_box {
      headline
      content
    }
    __typename
    ... on WordPressAcf_call_to_action {
      headline
      link {
        url
        title
        target
      }
    }
    __typename
    ... on WordPressAcf_contact_info {
      headline
      phone
      email
      address {
        name
        street
        province
        postal
      }
    }
    __typename
    ... on WordPressAcf_features {
      features {
        icon
        headline
        description
        image {
          alt
          url {
            childImageSharp {
              fluid(quality: 90, maxWidth: 1440) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
    __typename
    ... on WordPressAcf_bullet_list {
      headline
      column {
        list {
          item
        }
      }
      link {
        url
        title
        target
      }
    }
    __typename
    ... on WordPressAcf_cards {
      cards {
        headline
        description
        featured_image {
          alt
          url {
            childImageSharp {
              fluid(quality: 90, maxWidth: 1440) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
    __typename
    ... on WordPressAcf_breadcrumbs {
      enabled
    }
    __typename
    ... on WordPressAcf_hero {
      headline
      background_image {
        alt
        url {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1440) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      size
    }
  }
`
